// extracted by mini-css-extract-plugin
export default {"add_button":"ContentSpaces_add_button__4-Rvu","content_spaces":"ContentSpaces_content_spaces__BtSV8"};